var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Loading as LoadingIcon } from "@bale/icons";
import clsx from "clsx";
import { getColorByName } from "../../../utils/color";
import { PrimaryColorNames } from "../../../theme";
import styles from "./Loading.module.scss";
const Loading = (_a) => {
    var { className, color } = _a, props = __rest(_a, ["className", "color"]);
    return (React.createElement(LoadingIcon, Object.assign({ color: color !== null && color !== void 0 ? color : getColorByName(PrimaryColorNames.color_primary_p_50), className: clsx(className, styles.Loading) }, props)));
};
export { Loading };
//# sourceMappingURL=Loading.js.map